module.exports = __webpack_public_path__ + "static/media/9_r_derevy_79.32_73.43.10982979.png";